<div #sidebarRef class="sidebar" [ngClass]="{ expanded: isExpanded }">
  <div class="menu-list">
    <div
      #listItem
      data-href="/"
      class="menu-item menu-item--active"
      [ngClass]="{ 'menu-item--active': getIsHomePage() }"
      (click)="onMenuItemClick($event)"
      [style.display]="
        (screenAccess$ | async)?.includes('ALL') || (screenAccess$ | async)?.includes('RECS') ? 'flex' : 'none'
      "
    >
      <ion-icon class="menu-icon" name="home-outline"></ion-icon>
      <div class="menu-title">Recs SKU</div>
    </div>
    <div
      #listItem
      data-href="/void"
      class="menu-item"
      [ngClass]="{ 'menu-item--active': selectedPageHref.includes('/void') }"
      (click)="onMenuItemClick($event)"
      [style.display]="
        (screenAccess$ | async)?.includes('ALL') || (screenAccess$ | async)?.includes('VOIDS') ? 'flex' : 'none'
      "
    >
      <ion-icon class="menu-icon" name="receipt-outline"></ion-icon>
      <div class="menu-title">Void Closure Tool</div>
    </div>
    <div
      #listItem
      data-href="/history"
      class="menu-item"
      [ngClass]="{ 'menu-item--active': selectedPageHref === '/history' }"
      (click)="onMenuItemClick($event)"
      [style.display]="
        (screenAccess$ | async)?.includes('ALL') || (screenAccess$ | async)?.includes('RECS') ? 'flex' : 'none'
      "
    >
      <ion-icon class="menu-icon" name="timer-outline"></ion-icon>
      <div class="menu-title">Rec SKU History</div>
    </div>
    <div
      #listItem
      data-href="/report"
      class="menu-item"
      [ngClass]="{ 'menu-item--active': selectedPageHref === '/report' }"
      (click)="onMenuItemClick($event)"
      [style.display]="
        (screenAccess$ | async)?.includes('ALL') || (screenAccess$ | async)?.includes('RECS') ? 'flex' : 'none'
      "
    >
      <ion-icon class="menu-icon" name="stats-chart-outline"></ion-icon>
      <div class="menu-title">Rec Loop Report</div>
    </div>
  </div>
  
  <div class="sidebar-footer">
    <ion-button fill="clear" id="present-alert" class="support-btn" (click)="supportMenu()">
        <div class="footer-content">
          <img src="assets/icon/user-guide.svg" alt="user guide icon" class="menu-icon" />
          <div class="menu-title">User Guide</div>
        </div>
    </ion-button>
    
    <ion-alert
        trigger="present-alert"
        header="USER GUIDE"
        message="Do you want to download the User Guide?"
        [buttons]="alertButtons"
        (didDismiss)="setResult($event)"
      ></ion-alert>
    </div>
    <div class="highlighter" [ngStyle]="{ 'top.px': highlighterPos + 7 }"></div>

  <!-- The toggle button remains in place -->
  <!-- <div class="toggle-btn" (click)="toggleSidebar()">
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </div> -->
</div>
